
import { doc, setDoc,Timestamp, writeBatch } from "firebase/firestore";
import { auth, db } from "../firebaseConfig"; // Firestore reference

export async function logToast(message,user) 
{
    try
    {
        const user = auth.currentUser;
        const statusRef = doc(db, "appToastMessages", user.uid);
        await setDoc(statusRef, { message:message, createdDate :Timestamp.now()  }); //Adding timestamp so that snapshot triggers even it is the same text in the message

    } catch(error)
    {
        console.log(error);
    }
}
